import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useSWRMutation from 'swr/mutation';
import { gql } from 'graphql-request';
import { GraphQLRequestProps, request } from '@repo/ui/src/utils/graphql-request';

interface Input {
  email?: string;
  emailSubscribe?: boolean;
  sourceDetail?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  smsSubscribe?: boolean;
}

const EMAIL_SIGNUP = gql`
  mutation TrackMarketingSignupCompleted($input: TrackMarketingSignupCompletedInput!) {
    trackMarketingSignupCompleted(input: $input) {
      errors
      success
    }
  }
`;

const fetcher = (
  props: GraphQLRequestProps,
  {
    arg: {
      email: rawEmail,
      emailSubscribe,
      smsSubscribe,
      sourceDetail,
      firstName,
      lastName,
      phoneNumber,
    },
  }: { arg: Input },
) => {
  const email = rawEmail?.toLowerCase();

  return request({
    ...props,
    variables: {
      input: {
        emailSubscribe,
        smsSubscribe,
        sourceDetail,
        firstName,
        lastName,
        phoneNumber,
        source: 'traeger_website',
        email,
      },
    },
  });
};

export const useEmailSignup = () => {
  const { locale } = useCurrentUrl();
  return useSWRMutation({ document: EMAIL_SIGNUP, locale }, fetcher);
};
